import React, { useState } from "react";
import vdo from "../../assets/video/3d-cycled-animation-of-glowing-heartbeat-line-puls-2025-05-08-01-53-51-utc.mp4";
import fallback from "../../assets/images/ezgif-frame-042.jpg";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const HomePageBanner = () => {
  const [videoError, setVideoError] = useState(false);

  const container = {
    hidden: {},
    visible: {
      transition: {
        delayChildren: 1,
        staggerChildren: 0.1,
      },
    },
  };

  const item = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 1, duration: 1, ease: "easeInOut" }}
      className="relative w-full h-screen overflow-hidden flex justify-center items-center"
    >
      {!videoError ? (
        <video
          autoPlay
          muted
          loop
          onError={() => setVideoError(true)}
          className="absolute top-0 left-0 w-full h-full object-cover -z-10"
          style={{
            background:
              "linear-gradient(0deg, rgb(2, 0, 2) 0%, rgba(2, 0, 2, 0.3) 33%, rgba(2, 0, 2, 0) 100%)",
          }}
        >
          <source src={vdo} type="video/mp4" />
        </video>
      ) : (
        <img
          src={fallback}
          alt="Fallback"
          className="absolute top-0 left-0 w-full h-full object-cover"
        />
      )}

      <div className="text-white  text-center">
        {/* Mobile Buttons - Show only on small screens */}
        <div className="md:hidden flex flex-col items-center gap-4 mb-6">
          <Link to="/contact ">
            <button className="group relative inline-flex h-14 mt-6 w-full items-center font-Antique rounded-full px-10 py-8  text-sm md:text-xl font-light text-black bg-transparent overflow-hidden">
              <span className="absolute inset-0 rounded-full bg-[#cfa751] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
                <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                  <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                  <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                  <span className="absolute inset-0 rounded-full bg-[#cfa751] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                </span>
              </span>

              <span className="relative">
                <span className="flex flex-row gap-2 justify-center  items-center group-hover:opacity-0 group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                  Contact Us Now
                </span>
                <span className="absolute flex flec-row gap-2 top-0 opacity-0 translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                  Contact Us Now
                </span>
              </span>
            </button>
          </Link>
          <Link
            to="/make-a-payment"
            className="nav-cta button button-outlined"
            data-button-svg=""
          >
            <span className="button-inner">
              <span className="button-inner-static">Make a Payment</span>
              <span className="button-inner-hover">Make a Payment</span>
            </span>
            <span>
              <svg
                className="button-outlined-bg"
                enableBackground="new 0 0 153.81333333333333 56"
                viewBox="0 0 153.81333333333333 56"
                xmlns="http://www.w3.org/2000/svg"
              >
                <clipPath id="buttonSvg_U5NPDA2Q2">
                  <path
                    className="button-stroke"
                    d="m125.81333333333333 1c14.9 0 27 12.1 27 27s-12.1 27-27 27h-97.81333333333333c-14.9 0-27-12.1-27-27s12.1-27 27-27zm0-1h-97.81333333333333c-15.5 0-28 12.5-28 28 0 15.5 12.5 28 28 28h97.81333333333333c15.5 0 28-12.5 28-28 0-15.5-12.5-28-28-28z"
                  />
                </clipPath>
                <g clipPath="url(#buttonSvg_U5NPDA2Q2)">
                  <g className="button-circles">
                    <g className="button-circles-o">
                      <circle
                        pathLength="1"
                        className="button-circle -layer-1"
                        strokeWidth="153.81333333333333"
                        cx="76.90666666666667"
                        cy="28"
                        r="76.90666666666667"
                      />
                      <circle
                        pathLength="1"
                        className="button-circle -layer-2"
                        strokeWidth="153.81333333333333"
                        cx="76.90666666666667"
                        cy="28"
                        r="76.90666666666667"
                      />
                      <circle
                        pathLength="1"
                        className="button-circle -layer-3"
                        strokeWidth="153.81333333333333"
                        cx="76.90666666666667"
                        cy="28"
                        r="76.90666666666667"
                      />
                      <circle
                        pathLength="1"
                        className="button-circle -layer-4"
                        strokeWidth="153.81333333333333"
                        cx="76.90666666666667"
                        cy="28"
                        r="76.90666666666667"
                      />
                    </g>
                    <circle
                      pathLength="1"
                      className="button-circle -hover"
                      strokeWidth="153.81333333333333"
                      cx="76.90666666666667"
                      cy="28"
                      r="76.90666666666667"
                    />
                  </g>
                </g>
              </svg>
            </span>
          </Link>
        </div>

        <h1 className=" leading-[1.8rem] md:leading-normal xl:leading-[4.5rem] 2xl:leadding-[6.5rem]  font-Antique">
          {/* Line 1 */}
          {/* <motion.div
            className="flex flex-wrap justify-center md:leading-10 leading-[50px] items-center font-semibold"
            variants={container}
            initial="hidden"
            animate="visible"
          >
            {"Radiologist Owned & Operated".split("").map((char, i) => (
              <motion.span variants={item} key={i}>
                {char === " " ? "\u00A0" : char}
              </motion.span>
            ))}
          </motion.div> */}

          {/* Line 2 */}
          <motion.div
            className="flex justify-center text-[50px] md:text-8xl lg:text-8xl xl:text-[8vw] 2xl:text-[10vw] leading-[50px] xl:leading-[40px] items-center md:pb-8 md:pt-10  2xl:pb-20 2xl:pt-32 font-SomeOne"
            variants={container}
            initial="hidden"
            animate="visible"
          >
            {"Radiologist Owned & Operated".split("").map((char, i) => (
              <motion.span variants={item} key={i + 40}>
                {char === " " ? "\u00A0" : char}
              </motion.span>
            ))}
          </motion.div>

          {/* Line 3 */}
          <motion.div
            className="flex flex-wrap justify-center md:leading-10  leading-[50px] mx-4 md:mx-0 items-center 2xl:mt-8 sm:mt-6 font-semibold sm:text-4xl text-center text-[22px] md:text-2xl lg:text-4xl xl:text-[3vw] 2xl:text-[2.5vw]"
            variants={container}
            initial="hidden"
            animate="visible"
          >
            {"Citrus County, Florida's Premier Imaging Provider".split("").map((char, i) => (
              <motion.span variants={item} key={i + 60}>
                {char === " " ? "\u00A0" : char}
              </motion.span>
            ))}
          </motion.div>
        </h1>
      </div>
    </motion.div>
  );
};

export default HomePageBanner;
